import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export type PersonType = "PERSONNE_PHYSIQUE" | "PERSONNE_MORALE";
export type PersonTypeShort = "PP" | "PM";
export type PersonTypeFull = "Personne physique" | "Personne morale";

export function mapPersonType(type: PersonType): PersonTypeShort;
export function mapPersonType(
  type: PersonType,
  format: "short"
): PersonTypeShort;
export function mapPersonType(type: PersonType, format: "full"): PersonTypeFull;
export function mapPersonType(
  type: PersonType,
  format: "short" | "full" = "short"
) {
  if (format === "full") {
    return type === "PERSONNE_PHYSIQUE"
      ? "Personne physique"
      : "Personne morale";
  }
  return type === "PERSONNE_PHYSIQUE" ? "PP" : "PM";
}

export const onlyLetters = (value: string): boolean => {
  const regex = /^[A-Za-zÀ-ÖØ-öø-ÿ\s-]+$/;
  return regex.test(value);
};

// Numero local (indicatif pays stocke a part, ex. countryCode="+225") : la longueur du numero
// significatif varie d'un pays a l'autre (8 chiffres pour certains pays, 10 pour la CI, jusqu'a
// 15 pour d'autres selon l'UIT E.164) - une longueur fixe rejetait tout numero saisi avec un
// indicatif different de celui suppose par defaut.
export const isValidPhoneNumber = (value: string): boolean => {
  const regex = /^\d{8,15}$/;
  return regex.test(value);
};

// Vérifier le format email avec une regex
const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
export const isValidEmail = (value: string): boolean => {
  return emailRegex.test(value);
};

export const getIpAddress = async () => {
  const res = await fetch("https://api.ipify.org?format=json");
  const data = await res.json();

  return data.ip;
};

export const getDeviceFingerprint = async () => {
  // Chargement dynamique pour ne pas alourdir le bundle initial
  const { default: FingerprintJS } = await import(
    "@fingerprintjs/fingerprintjs"
  );
  const fp = await FingerprintJS.load();
  const result = await fp.get();

  return result.visitorId; // Empreinte unique
};
